export enum SearchTermType {
  Term = 'OPEN_SEARCH',
  Artist = 'ARTIST',
  Writer = 'WRITER',
  Title = 'TITLE',
  Album = 'ALBUM',
  Label = 'LABEL',
  Lyrics = 'LYRICS',
  ISRC = 'ISRC',
  SONG_CODE = 'SONG_CODE',
  Prompt = 'PROMPT',
  Keyword = 'OPEN_SEARCH',
  ExternalLink = 'EXTERNAL_LINK',
}
